<template>
  <BaseDialog
    title="功能列表顯示設定"
    class="member-center-show-edit-modal"
    width="670px"
    :btn1Loading="loading"
    @close="$emit('close')"
    @confirm="updateFunctionMenu"
  >
    <BaseElForm ref="formRef" :model="formData" :rules="formRules" label-position="left" label-width="200px">
      <BaseElFormItem label="會員顯示銷售消費紀錄" prop="showMember">
        <BaseElSwitch
          v-model="formData.showMember"
          class="switch-input"
          active-text="開啟顯示"
          inactive-text="關閉顯示"
        />
      </BaseElFormItem>
      <BaseElFormItem v-if="formData.showMember" prop="showMemberDetail" label="會員顯示銷售消費明細">
        <BaseElSwitch
          v-model="formData.showMemberDetail"
          class="switch-input"
          active-text="開啟顯示"
          inactive-text="關閉顯示"
        />
      </BaseElFormItem>
      <BaseElFormItem v-if="useHeadquarterShop" prop="orgSalesRecord" label="會員顯示組織銷售消費紀錄">
        <BaseElSwitch
          v-model="formData.orgSalesRecord"
          class="switch-input"
          active-text="開啟顯示"
          inactive-text="關閉顯示"
        />
      </BaseElFormItem>
      <BaseElFormItem v-if="formData.orgSalesRecord" prop="orgSalesRecordDetail" label="會員顯示組織銷售消費明細">
        <BaseElSwitch
          v-model="formData.orgSalesRecordDetail"
          class="switch-input"
          active-text="開啟顯示"
          inactive-text="關閉顯示"
        />
      </BaseElFormItem>
      <BaseElFormItem label="會員顯示常用地址">
        <BaseElSwitch
          v-model="formData.userInfoMoreAddress"
          class="switch-input"
          active-text="開啟顯示"
          inactive-text="關閉顯示"
        />
      </BaseElFormItem>

      <BaseElFormItem v-if="usePospalBalance" prop="posPalMemberTransaction" label="會員顯示瑞乘消費紀錄">
        <BaseElSwitch
          v-model="formData.posPalMemberTransaction"
          class="switch-input"
          active-text="開啟顯示"
          inactive-text="關閉顯示"
        />
      </BaseElFormItem>
      <BaseElFormItem v-if="usePospalTransaction" prop="posPalMemberWallet" label="會員顯示瑞乘會員餘額紀錄">
        <BaseElSwitch
          v-model="formData.posPalMemberWallet"
          class="switch-input"
          active-text="開啟顯示"
          inactive-text="關閉顯示"
        />
      </BaseElFormItem>
      <BaseElFormItem v-if="usePospalTransaction" prop="posPalMemberPassProduct" label="會員顯示瑞乘會員次卡紀錄">
        <BaseElSwitch
          v-model="formData.posPalMemberPassProduct"
          class="switch-input"
          active-text="開啟顯示"
          inactive-text="關閉顯示"
        />
      </BaseElFormItem>
      <BaseElFormItem v-if="useExternalTransaction" prop="externalMemberTransaction" label="會員顯示第三方消費紀錄">
        <BaseElSwitch
          v-model="formData.externalMemberTransaction"
          class="switch-input"
          active-text="開啟顯示"
          inactive-text="關閉顯示"
        />
      </BaseElFormItem>
      <BaseElFormItem v-if="useExternalTransaction && formData.externalMemberTransaction" prop="enableClientDisplayTimeRange" label="限定顯示區間">
        <BaseElSwitch
          v-model="formData.enableClientDisplayTimeRange"
          class="switch-input"
          active-text="限定"
          inactive-text="不限定"
        />
      </BaseElFormItem>
      <BaseElFormItem v-if="formData.externalMemberTransaction && formData.enableClientDisplayTimeRange" prop="clientDisplayTimeRangeStartAt" label="開始時間">
        <el-date-picker
          v-model="formData.clientDisplayTimeRangeStartAt"
          editable
          type="datetime"
          placeholder="選擇日期"
          format="yyyy/MM/dd HH:mm"
          date-format="yyyy/mm/dd"
          time-format="HH:mm"
        />
      </BaseElFormItem>
      <BaseElFormItem v-if="formData.externalMemberTransaction && formData.enableClientDisplayTimeRange" prop="clientDisplayTimeRangeEndAt" label="結束時間">
        <el-date-picker
          v-model="formData.clientDisplayTimeRangeEndAt"
          editable
          type="datetime"
          placeholder="選擇日期"
          format="yyyy/MM/dd HH:mm"
          date-format="yyyy/mm/dd"
          time-format="HH:mm"
        />
      </BaseElFormItem>
      <BaseElFormItem v-if="useRewardDistribution" prop="rewardDistribution" label="會員顯示獎勵發放活動">
        <BaseElSwitch
          v-model="formData.rewardDistribution"
          class="switch-input"
          active-text="開啟顯示"
          inactive-text="關閉顯示"
        />
      </BaseElFormItem>
      <BaseElFormItem v-if="useRewardDistribution" prop="rewardDistributionLinkUseRecord" label="會員顯示獎勵發放紀錄">
        <BaseElSwitch
          v-model="formData.rewardDistributionLinkUseRecord"
          class="switch-input"
          active-text="開啟顯示"
          inactive-text="關閉顯示"
        />
      </BaseElFormItem>
      <BaseElFormItem label="會員各管道消費累計">
        <BaseElSwitch
          v-model="formData.memberChannelExpenseData"
          class="switch-input"
          active-text="開啟顯示"
          inactive-text="關閉顯示"
        />
      </BaseElFormItem>
    </BaseElForm>
  </BaseDialog>
</template>

<script>
import { defineComponent, computed, onMounted } from 'vue'
import BaseDialog from '@/components/Dialog/BaseDialog.vue'
import { useBaseForm } from '@/use/useForm'
import { noEmptyRules } from '@/validation'
import { UpdateMemberCenterConfig, UpdateExternalTransactionConfig } from '@/api/member/memberCenter'
import { values, find, set as ObjSet } from 'lodash'
import store from '@/store'
import formUtils from '@/utils/form'
import { UpdateSalesConfig } from '@/api/sales'
export default defineComponent({
  name: 'MemberCardFuncShowEditModal',
  components: { BaseDialog },
  props: {
    configData: { type: Object, default: () => {} },
    useExternalTransaction: { type: Boolean, default: () => false },
    usePospalTransaction: { type: Boolean, default: () => false },
    usePospalBalance: { type: Boolean, default: () => false },
    functionMenuConfig: { type: Array, default: () => [] },
    useRewardDistribution: { type: Boolean, default: () => false },
    useHeadquarterShop: { type: Boolean, default: () => false },
  },
  emits: ['refresh', 'close'],
  setup (props, { emit }) {
    const shopId = computed(() => store.getters.shop)
    const { initFormData, formData, formRef, loading } = useBaseForm()
    initFormData({
      showMember: false,
      showMemberDetail: false,
      orgSalesRecord: false,
      orgSalesRecordDetail: false,
      posPalMemberWallet: false,
      posPalMemberPassProduct: false,
      posPalMemberTransaction: false,
      userInfoMoreAddress: false,
      externalMemberTransaction: false,
      rewardDistribution: false,
      rewardDistributionLinkUseRecord: false,
      enableClientDisplayTimeRange: false,
      clientDisplayTimeRangeStartAt: null,
      clientDisplayTimeRangeEndAt: null,
      memberChannelExpenseData: false,
    })

    const formRules = computed(() => {
      const rules = {
        clientDisplayTimeRangeStartAt: [noEmptyRules()],
      }
      return rules
    })

    const updateFunctionMenu = async () => {
      loading.value = true
      if (!await formUtils.checkForm(formRef.value)) {
        loading.value = false
        return
      }
      const config = props.functionMenuConfig
      const posPalMemberWallet = find(config, { type: 'posPalMemberWallet' })
      const posPalMemberTransaction = find(config, { type: 'posPalMemberTransaction' })
      const posPalMemberPassProduct = find(config, { type: 'posPalMemberPassProduct' })
      const memberChannelExpenseData = find(config, { type: 'memberChannelExpenseData' })
      const userInfoMoreAddress = find(config, { type: 'userInfoMoreAddress' })
      const externalMemberTransaction = find(config, { type: 'memberExternalTransaction' })
      if (posPalMemberWallet) {
        ObjSet(posPalMemberWallet, 'enable', formData.posPalMemberWallet)
      } else {
        config.push({ type: 'posPalMemberWallet', enable: formData.posPalMemberWallet })
      }
      if (posPalMemberPassProduct) {
        ObjSet(posPalMemberPassProduct, 'enable', formData.posPalMemberPassProduct)
      } else {
        config.push({ type: 'posPalMemberPassProduct', enable: formData.posPalMemberPassProduct })
      }
      if (posPalMemberTransaction) {
        ObjSet(posPalMemberTransaction, 'enable', formData.posPalMemberTransaction)
      } else {
        config.push({ type: 'posPalMemberTransaction', enable: formData.posPalMemberTransaction })
      }
      if (userInfoMoreAddress) {
        ObjSet(userInfoMoreAddress, 'enable', formData.userInfoMoreAddress)
      } else {
        config.push({ type: 'userInfoMoreAddress', enable: formData.userInfoMoreAddress })
      }
      if (memberChannelExpenseData) {
        ObjSet(memberChannelExpenseData, 'enable', formData.memberChannelExpenseData)
      } else {
        config.push({ type: 'memberChannelExpenseData', enable: formData.memberChannelExpenseData })
      }
      if (externalMemberTransaction) {
        ObjSet(externalMemberTransaction, 'enable', formData.externalMemberTransaction)
      } else {
        config.push({ type: 'memberExternalTransaction', enable: formData.externalMemberTransaction })
      }
      const rewardDistribution = find(config, { type: 'rewardDistribution' })
      const rewardDistributionLinkUseRecord = find(config, { type: 'rewardDistributionLinkUseRecord' })
      const orgSalesRecord = find(config, { type: 'orgSalesRecord' })
      const orgSalesRecordDetail = find(config, { type: 'orgSalesRecordDetail' })

      if (rewardDistribution) {
        ObjSet(rewardDistribution, 'enable', formData.rewardDistribution)
      } else {
        config.push({ type: 'rewardDistribution', enable: formData.rewardDistribution })
      }
      if (rewardDistributionLinkUseRecord) {
        ObjSet(rewardDistributionLinkUseRecord, 'enable', formData.rewardDistributionLinkUseRecord)
      } else {
        config.push({ type: 'rewardDistributionLinkUseRecord', enable: formData.rewardDistributionLinkUseRecord })
      }
      if (orgSalesRecord) {
        ObjSet(orgSalesRecord, 'enable', formData.orgSalesRecord)
      } else {
        config.push({ type: 'orgSalesRecord', enable: formData.orgSalesRecord })
      }
      if (orgSalesRecordDetail) {
        ObjSet(orgSalesRecordDetail, 'enable', formData.orgSalesRecordDetail)
      } else {
        config.push({ type: 'orgSalesRecordDetail', enable: formData.orgSalesRecordDetail })
      }
      const [, err] = await UpdateMemberCenterConfig({
        shopId: shopId.value,
        functionMenuSetting: config,
      })
      loading.value = false
      if (err) return window.$message.error(err)
      await updateMemberCard()
      // window.$message.success('更新成功！')
      // emit('refresh')
      // emit('close')
    }
    const updateMemberCard = async () => {
      try {
        await UpdateSalesConfig({
          shopId: shopId.value,
          showMember: formData.showMember,
          identityMode: undefined,
          showMemberDetail: formData.showMemberDetail,
          enableDisplayTransaction: undefined,
          enableDisplayBalance: undefined,
        })
        // this.$message.success('更新成功 !')
        await updateExternalTransactionConfig()
      } catch (error) {
        console.log(error)
        this.$message.error(error || error.message)
      }
    }
    const updateExternalTransactionConfig = async () => {
      const [, err] = await UpdateExternalTransactionConfig({
        shopId: shopId.value,
        enableClientDisplayTimeRange: formData.enableClientDisplayTimeRange,
        clientDisplayTimeRangeStartAt: formData.clientDisplayTimeRangeStartAt,
        clientDisplayTimeRangeEndAt: formData.clientDisplayTimeRangeEndAt,
      })
      if (err) return this.$message.error(err)
      window.$message.success('更新成功！')
      emit('refresh')
      emit('close')
    }

    const syncData = () => {
      for (const key in props.configData) {
        console.log(key, props.configData[key])
        formData[key] = props.configData[key]
      }
    }

    const disabledOption = (type) => {
      const selected = values(formData)
      const exist = selected.includes(type)
      return exist
    }

    onMounted(() => {
      syncData()
    })

    return { formData, formRef, formRules, updateFunctionMenu, find, disabledOption, loading }
  },
})
</script>

<style lang="postcss" scoped>

</style>
